import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams, useOutletContext, Outlet } from "react-router";
import { NavList, SubNav } from "components/Nav";
import { useLinks } from "hooks";

/**
 * Settings
 */
const Settings = () => {
  const { teamPermissions, isSLTL, ...restContext } = useOutletContext();
  const [navItems, setNavItems] = useState([]);
  const { id } = useParams();
  const intl = useIntl();
  const links = useLinks();

  useEffect(() => {
    setNavItems(NAV_ITEMS(id, teamPermissions, links).filter((page) => page.isPermissible));
  }, [teamPermissions]);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Squads.Settings.Title" })}</title>
      </Helmet>
      <SubNav>
        <NavList pages={navItems} />
      </SubNav>
      <Outlet context={{ teamPermissions, isSLTL, ...restContext }} />
    </>
  );
};

const NAV_ITEMS = (id, teamPermissions, links) => [
  {
    label: <FormattedMessage id="Squads.SquadSubNav.Settings.GeneralSettings" />,
    to: links.squad_settings(id),
    isPermissible: teamPermissions?.canAccessGeneralSettings,
    props: {
      routerEnabled: true,
      end: true,
      isActive: true,
    },
  },
  {
    label: <FormattedMessage id="Squads.SquadSubNav.Settings.DailyReportSettings" />,
    to: links.squad_daily_report_settings(id),
    isPermissible: teamPermissions?.canAccessDailyReportSettings,
    props: {
      routerEnabled: true,
      end: true,
      isActive: true,
    },
  },
  {
    label: <FormattedMessage id="Squads.SquadSubNav.Settings.SignalInstallation" />,
    to: links.squad_signal_installation_settings(id),
    isPermissible: teamPermissions?.canAccessSignalInstallation,
    props: {
      routerEnabled: true,
      end: true,
      isActive: true,
    },
  },
  {
    label: <FormattedMessage id="Squads.SquadSubNav.Settings.SignalSettings" />,
    to: links.squad_engineering_metrics_settings(id),
    isPermissible: teamPermissions?.canAccessMetricsSettings,
    props: {
      routerEnabled: true,
      end: true,
      isActive: true,
    },
  },
];

export default Settings;
